import { render, staticRenderFns } from "./AccountabilityProgram.vue?vue&type=template&id=6e8ec5e8&"
import script from "./AccountabilityProgram.vue?vue&type=script&lang=js&"
export * from "./AccountabilityProgram.vue?vue&type=script&lang=js&"
import style0 from "./AccountabilityProgram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports